// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1FHKb","image":"Header_image__3l2Bo","name":"Header_name__10sx1","info":"Header_info__V6F25","infoRow":"Header_infoRow__1k5ZH"};